import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { GridService } from 'app/Shared/Services/grid.service';
import {default as CATGridColumnsJSON} from 'app/Shared/Constant/Grid Column Names/CAT-ROE-Viewer-Columns.json';
import {default as AggoGridColumnsJSON} from './aggo-grid-columns.json';
import {default as AggoExecutionGridColumnsJSON} from './aggo-execution-grid-columns.json';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { HttpErrorResponse } from '@angular/common/http';
import { CommonModule,DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { map } from 'rxjs';
import { TurboTableComponent } from 'app/Shared/Component/turbo-table/turbo-table.component';
import { EventTreeComponent } from 'app/Shared/Component/event-tree/event-tree.componenet';

@Component({
    selector: 'app-representative-order',
    imports: [CommonModule, ButtonModule, MatTooltipModule, TableModule, MatExpansionModule,
        MatChipsModule, MatProgressSpinnerModule, MatChipsModule, ConfirmDialogModule, EventTreeComponent,
        FormsModule, DialogModule, TurboTableComponent],
    templateUrl: './representative-order.component.html',
    styleUrls: ['./representative-order.component.scss']
})
export class RepresentativeOrderComponent implements OnInit {
  @Output() closeEventRepresentativeDialog: EventEmitter<boolean> = new EventEmitter();
  @Input('SelectedRow') selectedRow: any[] = [];
  @Input('isRepresentativeOrderDisplay') isRepresentativeOrderDisplay: boolean = false;
  isDataLoading: boolean = true;
  panelOpenState: boolean = false;
  AggregatedOrdersData: any[] = [];
  AggregatedOrdersSummary: any = { "sumOfQuantity": 0, "weightedPrice": 0, "minPrice": 0, "maxPrice": 0 }
  AggregatedOrdersExecutionData: any[] = [];
  AggregatedOrdersExecutionSummary: any = { "sumOfQuantity": 0, "weightedPrice": 0, "minPrice": 0, "maxPrice": 0 };
  reportDate: string = "";
  todate: string = "";
  orderID: string = "";
  symbol: string = "";
  type: string = "";
  side: string = "";
  orderDate: string = "";
  firmROEID: string = "";
  quantity: string = "";
  price: string = "";
  orderType:string="";
  representativeInd: string = "";
  CATGridColumns: any = [];
  AggoGridColumns: any = [];
  AggoExecutionGridColumns: any = [];

  constructor(public gridService: GridService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private userService: UserService,
    public constantService: ConstantService,
    public date: DatePipe,) {
    this.CATGridColumns = this.gridService.getGridColumns(CATGridColumnsJSON["CAT-ROE-Grid-Columns"]);
    this.AggoExecutionGridColumns = this.gridService.getGridColumns(AggoExecutionGridColumnsJSON);
    this.AggoGridColumns = this.gridService.getGridColumns(AggoGridColumnsJSON);
    this.CATGridColumns.splice(0, 1); // *** note removed action column */
  }

  ngOnInit() {
    let row = this.selectedRow[0];
    this.firmROEID = row['firmROEID'];
    this.orderID = row['orderID'];
    this.reportDate = row['reportDate'];
    this.todate = row['reportDate'];
    this.type = row['type'];
    this.symbol = row['symbol'];
    this.side = row['side'];
    this.quantity = row['quantity'];
    this.price = row['price'];
    this.orderDate = row['orderKeyDate'];
    this.representativeInd = row['representativeInd'];
    this.orderType = row['orderType'];
    this.getRepresentativeAggoOrders();
    this.getRepresentativeAggoOrdersExecution();
  }


  closeDialogbox() {
    this.isRepresentativeOrderDisplay = false;
    this.closeEventRepresentativeDialog.emit(true);
  }

  getRepresentativeAggoOrders() {
    let payload = {
      mpid: this.userService.getActiveMPID(),
      orderID: this.orderID,
      symbol: this.symbol,
      todate: this.todate,
      startLimit: 0,
      endLimit: 1000
    };

    this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.Representative_Aggo_Orders,), payload)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (Element: any) => {
          this.isDataLoading = false;
            let dataset: any = Element;
            if (dataset.summary)
              this.AggregatedOrdersSummary = dataset.summary[0];
            if (dataset.details)
              this.AggregatedOrdersData = dataset.details;
        },
        error: (err: HttpErrorResponse) => {
          this.isDataLoading = false;
        }
      });
  }


  getRepresentativeAggoOrdersExecution() {
    let payload = {
      mpid: this.userService.getActiveMPID(),
      orderID: this.orderID,
      symbol: this.symbol,
      todate: this.todate,
      startLimit: 0,
      endLimit: 1000
    };
    this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.Representative_Aggo_Order_Execution,), payload)
      .pipe(map((response: Response) => {
        return response;
      }))
      .subscribe({
        next: (Element: any) => {
          this.isDataLoading = false;
        let dataset: any = Element;
        if (dataset.summary)
          this.AggregatedOrdersExecutionSummary = dataset.summary[0];
        if (dataset.details)
          this.AggregatedOrdersExecutionData = dataset.details;
        },
        error: (err: HttpErrorResponse) => {
          this.isDataLoading = false;
        }
      });  
  }

  getRepresentativeIndDetails(value: string) {
    if (value.toLocaleUpperCase() == 'Y') {
      return '“Y”, Representative order, linkage required ';
    } else if (value.toLocaleUpperCase() == 'YS') {
      return '“YS”, Representative order, linkage required, details in supplement event';
    } else if (value.toLocaleUpperCase() == 'YP') {
      return '“YP”, Representative order,pricing guarantee, no linkage required';
    } else if (value.toLocaleUpperCase() == 'YE') {
      return '“YE”, Representative eligible, Order eligible for customer fills via an unlinked system ';
    } else if (value.toLocaleUpperCase() == 'O') {
      return '“O”, Option combined order, linkage required';
    } else if (value.toLocaleUpperCase() == 'OS') {
      return '“OS” Option combined order, linkage required, details in supplement event ';
    }
    return;
  }
}
